import { action, createRequestTypes } from './base';

export const docConfigActionTypes = {
  GET_DOC_CONFIG: createRequestTypes('GET_DOC_CONFIG'),
  UPDATE_DOC_CONFIG: createRequestTypes('UPDATE_DOC_CONFIG'),
};

class DocConfigActions {
  /**
     *
     * @param tenantId
     * @param entityName
     * @param page
     * @param limit
     * @returns {{type: *}}
     */
       getDocConfig = (tenantId, entityName, callback) => action(docConfigActionTypes.GET_DOC_CONFIG.REQUEST, {
         tenantId, entityName, callback,
       });

      /**
       *
       * @param getDocConfigLoading
       * @returns {{type: *}}
       */
      getDocConfigLoading = (getDocConfigLoading, entityName) => action(docConfigActionTypes.GET_DOC_CONFIG.LOADING, {
        getDocConfigLoading,
        entityName,
      });

      /**
       *
       * @param docConfigSuccess
       * @returns {{type: *}}
       */
      getDocConfigSuccess = (docConfig, entityName) => action(docConfigActionTypes.GET_DOC_CONFIG.SUCCESS, {
        docConfig,
        entityName,
      });

      updateDocConfigLoading = (updateDocConfigLoading) => action(docConfigActionTypes.UPDATE_DOC_CONFIG.LOADING, {
        updateDocConfigLoading,
      })

      updateDocConfig = (payload, callback) => action(docConfigActionTypes.UPDATE_DOC_CONFIG.REQUEST, {
        payload, callback,
      })
}

export default new DocConfigActions();
